export default __webpack_public_path__ + "static/trackthebat7-5979dabfc1e81a3b9c80ef7660e966cf.png";